/*
 * Copyright (c) 2019 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { ErrorModel } from '../model/error.model';
import { ErrorSeverityEnum } from '../consts/error-severity.enum';

//TODO rename to iriroMinLngth
@Directive({
  selector: '[minLength], [iriro-minLength]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MinimumLengthValidator,
      multi: true,
    }
  ],
})
export class MinimumLengthValidator implements Validator {
  @Input() minLength: number | undefined = undefined;
  @Input() field: string | null = null;

  validate(control: AbstractControl): { [key: string]: any } | null {
    const funcProperties = {
      min: this.minLength,
      field: this.field,
    };
    return _minLengthValidation.bind(funcProperties)(control);
  }
}

export const minLengthValidator = (minLength: any): ValidatorFn => {
  const funcProperties = {
    min: minLength,
  };

  return _minLengthValidation.bind(funcProperties);
};

function _minLengthValidation(this: any, control: AbstractControl): {
  [key: string]: any;
} | null {
  let errors: ErrorModel | null = null;

  if (
    control.value &&
    this.min != undefined &&
    control.value.length < this.min
  ) {
    errors = {
      severity: ErrorSeverityEnum.error,
      message: 'minLength' + (this.field ? this.field : this.min),
    };
  }

  return errors ? errors : null;
}
